"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PROPERTY_SUFFIX;
(function (PROPERTY_SUFFIX) {
    PROPERTY_SUFFIX["NO_SUFFIX"] = "";
    PROPERTY_SUFFIX["PIXEL"] = "px";
    PROPERTY_SUFFIX["PERCENTAGE"] = "%";
    PROPERTY_SUFFIX["DEG"] = "deg";
    PROPERTY_SUFFIX["SECONDS"] = "s";
})(PROPERTY_SUFFIX = exports.PROPERTY_SUFFIX || (exports.PROPERTY_SUFFIX = {}));
var PROPERTY_TYPE;
(function (PROPERTY_TYPE) {
    PROPERTY_TYPE["TYPELESS"] = "typeless";
    PROPERTY_TYPE["STYLE"] = "style";
    PROPERTY_TYPE["TRANSFORM"] = "transform";
    PROPERTY_TYPE["ATTRIBUTE"] = "attribute";
})(PROPERTY_TYPE = exports.PROPERTY_TYPE || (exports.PROPERTY_TYPE = {}));
var TYPE;
(function (TYPE) {
    TYPE["HTML"] = "html";
    TYPE["CANVAS"] = "canvas";
    TYPE["SVG"] = "svg";
})(TYPE = exports.TYPE || (exports.TYPE = {}));
